module.exports = __webpack_public_path__ + "img/bg.58afe36c.png";